import es from './es';
import pt from './pt';
import de from './de';
import nl from './nl';
import {
    isCountrySpain,
    isCountryPortugal,
    isCountryGermany,
    isCountryNetherlands,
} from 'utilities/multiLanguageHelper';

export const getConfig = () => {
    if (isCountrySpain()) return es[window.__ENV__];
    else if (isCountryPortugal()) return pt[window.__ENV__];
    else if (isCountryGermany()) return de[window.__ENV__];
    else if (isCountryNetherlands()) return nl[window.__ENV__];

    return es[__ENV__];
};
